export const eventValidationConstants = {
  EVENT_TITLE_MAX_LENGTH: 'Title must be less than 100 characters',
  EVENT_DESCRIPTION_MAX_LENGTH: 'Description must be less than 500 characters',
  EVENT_TITLE_MISSING_WARNING_CONTENT: 'Title is missing for this event. If left blank, the event name will be \'Untitled\'. Proceed with saving the event?',
  EVENT_TITLE_MISSING_WARNING_TITLE: 'Missing Title',
  EVENT_PAST_DATE_WARNING_CONTENT: 'Date of this event is past date. Proceed with saving the event?',
  EVENT_PAST_DATE_WARNING_TITLE: 'Past Date',
}
